import { type FeatureModule } from '@store/features/types';

/**
 * Service Facilities feature module definition
 *
 * API-only feature for managing service facility locations (CMS-1500 Box 32).
 * Uses RTK Query for all data fetching and caching.
 */
export const serviceFacilitiesFeature: FeatureModule = {
  id: 'serviceFacilities',
  name: 'Service Facilities',

  dependencies: [],

  reducers: {},
  middleware: [],

  persistence: {
    enabled: false,
  },

  sync: {
    enabled: false,
  },

  setup: _store => {},
  cleanup: _store => {},
};
